// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========== Base Styles ========== */
.clinic-chat-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: var(--clr-grey-10);
  margin: 1rem;
  padding: 10px;
  box-sizing: border-box;
  position: relative;
  overflow: auto;
  border: 3px solid var(--clr-primary-3);
}

.clinic-chat-page {
  display: flex;
  flex-direction: row;
  background-color: var(--clr-white);
  width: 90%;
  max-width: 1200px;
  min-width: 700px;
  min-height: 500px;
  height: 80vh;
  border-radius: 10px;
  overflow: auto;
  box-shadow: var(--shadow-3);
  resize: both;
  position: relative;
}

.clinic-chat-page::after {
  content: '';
  position: absolute;
  width: 16px;
  height: 16px;
  right: 0;
  bottom: 0;
  background: transparent;
  cursor: se-resize;
}

.chat-sidebar {
  width: 250px;
  min-width: 180px;
  max-width: 400px;
  flex-shrink: 0;
  background-color: var(--grey-100);
  padding: 1rem;
  overflow-y: auto;
  border-right: 1px solid var(--grey-300);
  transition: all 0.3s ease;
  z-index: 99;
}

.sidebar-header {
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}
.sidebar-header-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 8px;
}

.collapse-btn {
  background: none;
  border: none;
  font-size: 1.2rem;
  cursor: pointer;
  color: var(--grey-500);
  transition: color 0.2s;
}

.collapse-btn:hover {
  color: var(--clr-primary-5);
}

.patient-search {
  width: 100%;
  padding: 0.5rem 0.75rem;
  margin-bottom: 1rem;
  border: 1px solid var(--grey-300);
  border-radius: 6px;
  font-size: 0.95rem;
}

.chat-sidebar h2 {
  margin: 0;
  font-size: 1.1rem;
  color: var(--clr-grey-2);
}

.chat-participant {
  padding: 0.75rem;
  border-radius: 6px;
  margin-bottom: 0.5rem;
  cursor: pointer;
  transition: background 0.2s ease;
  background-color: var(--clr-white);
}

.chat-participant:hover {
  background-color: var(--grey-200);
}

.chat-participant.active {
  background-color: var(--clr-primary-9);
  font-weight: bold;
}

.chat-main {
  flex-grow: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  background-color: var(--clr-white);
  overflow: hidden;
  height: 100%;
  max-height: 100%;
}

.chat-header {
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  padding: 1rem 1.5rem;
  background-color: var(--clr-primary-5);
  color: var(--clr-white);
  font-size: 1.1rem;
  font-weight: bold;
  box-shadow: var(--shadow-1);
}

.chat-header button {
  background: none;
  border: none;
  font-size: 1.2rem;
  color: var(--clr-white);
  cursor: pointer;
  margin-right: 0.75rem;
}

.channel-tabs {
  display: flex;
  gap: 1rem;
  padding: 0.75rem 1.5rem;
  border-bottom: 1px solid var(--grey-300);
  background-color: var(--grey-100);
  font-size: 0.9rem;
  font-weight: 500;
}

.channel-tabs button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px 12px;
  border-radius: 4px;
  transition: background 0.2s;
  color: var(--clr-primary-5);
}

.channel-tabs button:hover {
  background-color: var(--clr-primary-10);
}

.channel-tabs button.active {
  background-color: var(--clr-primary-5);
  color: var(--clr-white);
}

.chat-body {
  flex: 1 1;
  padding: 1rem 1.5rem;
  overflow-y: auto;
  background-color: var(--grey-100);
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.chat-msg {
  max-width: 60%;
}

.chat-msg.patient {
  align-self: flex-start;
}

.chat-msg.clinic {
  align-self: flex-end;
}

.chat-bubble {
  padding: 0.75rem 1rem;
  border-radius: 18px;
  background-color: var(--grey-200);
  font-size: 0.95rem;
  position: relative;
  color: var(--grey-900);
  box-shadow: var(--shadow-1);
}

.chat-msg.clinic .chat-bubble {
  background-color: var(--clr-primary-9);
  color: var(--clr-primary-1);
}

.chat-bubble.email-channel {
  border-left: 4px solid #ff9800;
  background-color: #fff8e1;
  color: #5d4037;
}

.chat-channel-label {
  display: inline-block;
  font-size: 0.65rem;
  background-color: #ff9800;
  color: white;
  padding: 2px 6px;
  border-radius: 10px;
  margin-top: 6px;
  margin-left: 4px;
  font-weight: bold;
}

.chat-time {
  font-size: 0.75rem;
  margin-top: 0.25rem;
  text-align: right;
  color: var(--grey-600);
}

.chat-input-bar {
  position: sticky;
  bottom: 0;
  padding: 1rem 1.5rem;
  display: flex;
  gap: 1rem;
  border-top: 1px solid var(--grey-300);
  background-color: var(--grey-50);
  z-index: 10;
}

.chat-input-bar input {
  flex: 1 1;
  padding: 0.7rem 1rem;
  border: 1px solid var(--grey-300);
  border-radius: 20px;
  font-size: 1rem;
}

.chat-input-bar button {
  padding: 0.7rem 1.5rem;
  border: none;
  border-radius: 20px;
  background-color: var(--clr-primary-5);
  color: var(--clr-white);
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.chat-input-bar button:hover {
  background-color: var(--clr-primary-4);
}

.sidebar-resizer {
  width: 6px;
  min-width: 6px;
  cursor: col-resize;
  background-color: var(--grey-300);
  transition: background-color 0.2s ease;
}

.sidebar-resizer:hover {
  background-color: var(--grey-400);
}

.sidebar-resizer::after {
  content: '';
  display: block;
  width: 2px;
  height: 40%;
  margin: auto;
  background-color: var(--grey-500);
}

.collapsed-toggle {
  width: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--grey-100);
  border-right: 1px solid var(--grey-300);
}

.collapsed-toggle button {
  background: none;
  border: none;
  font-size: 1.2rem;
  cursor: pointer;
  color: var(--grey-500);
  transition: color 0.2s;
}

.collapsed-toggle button:hover {
  color: var(--clr-primary-5);
}

.clinic-chat-wrapper.fullscreen {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background-color: var(--grey-100);
  padding: 0;
}

.clinic-chat-wrapper.fullscreen .clinic-chat-page {
  width: 100vw;
  height: 100vh;
  max-width: none;
  max-height: none;
  border-radius: 0;
  resize: none;
}

.fullscreen-toggle {
  position: absolute;
  top: 10px;
  right: 20px;
  z-index: 99;
}

.fullscreen-toggle button {
  background-color: var(--clr-primary-5);
  color: var(--clr-white);
  border: none;
  padding: 6px 12px;
  font-size: 0.85rem;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.fullscreen-toggle button:hover {
  background-color: var(--clr-primary-4);
}

@media (max-width: 768px) {
  .chat-sidebar {
    width: 100% !important;
  }

  .chat-main {
    display: none;
  }

  .chat-main.active {
    display: block;
    width: 100%;
  }

  .clinic-chat-page {
    flex-direction: column;
    width: 100%;
    height: 100vh;
    min-width: auto;
    min-height: auto;
    border-radius: 0;
    box-shadow: none;
    resize: none;
  }

  .chat-sidebar {
    height: 100%;
    border-right: none;
    border-bottom: 1px solid var(--grey-300);
    position: relative;
    z-index: 2;
    overflow-y: auto;
  }

  .chat-main {
    position: absolute;
    top: 0;
    left: 0;
    background: var(--clr-white);
    z-index: 3;
    display: none;
    flex-direction: column;
  }

  .chat-main.active {
    display: flex;
  }

  .chat-header {
    padding: 1rem;
    font-size: 1rem;
    justify-content: flex-start;
  }

  .channel-tabs {
    padding: 0.5rem 1rem;
    gap: 0.5rem;
  }

  .chat-body {
    padding: 0.75rem 1rem;
    gap: 0.75rem;
  }

  .chat-input-bar {
    padding: 0.75rem 1rem;
  }

  .chat-input-bar input,
  .chat-input-bar button {
    font-size: 0.9rem;
  }

  .fullscreen-toggle,
  .sidebar-resizer,
  .collapsed-toggle {
    display: none;
  }
}

.welcome-message {
  padding: 30px;
  text-align: center;
  color: var(--clr-grey-3);
  background-color: var(--grey-50);
  border-radius: 12px;
  margin: 40px auto;
  max-width: 675px;
  box-shadow: var(--shadow-1);
  font-family: var(--ff-secondary);
}

.welcome-message h3 {
  font-size: 24px;
  margin-bottom: 16px;
  color: var(--clr-grey-1);
}

.welcome-message p {
  font-size: 16px;
  line-height: 1.6;
  color: var(--grey-700);
}

.sidebar-subtitle {
  font-size: 0.9rem;
  color: var(--grey-600);
  margin-top: 4px;
  margin-bottom: 12px;
}

.sidebar-search-container {
  padding: 0 12px 12px;
}

.patient-search {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid var(--grey-300);
  border-radius: 6px;
  font-size: 0.95rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/ChatWindow/ClinicChatView.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,oCAAoC;EACpC,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,SAAS;EACT,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,iCAAiC;EACjC,aAAa;EACb,gBAAgB;EAChB,uCAAuC;EACvC,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,iCAAiC;EACjC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;EACtC,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kCAAkC;EAClC,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,sCAAsC;EACtC,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,wCAAwC;EACxC,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,sCAAsC;EACtC,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,oBAAoB;EACpB,gBAAgB;EAChB,iCAAiC;EACjC,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,iCAAiC;EACjC,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,oBAAoB;EACpB,aAAa;EACb,SAAS;EACT,qCAAqC;EACrC,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,SAAO;EACP,oBAAoB;EACpB,iCAAiC;EACjC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,sCAAsC;EACtC,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,iCAAiC;EACjC,sCAAsC;AACxC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,cAAc;EACd,UAAU;EACV,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iCAAiC;EACjC,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,iCAAiC;EACjC,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;AACb;;AAEA;EACE,sCAAsC;EACtC,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,wCAAwC;IACxC,kBAAkB;IAClB,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,4BAA4B;IAC5B,UAAU;IACV,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,eAAe;IACf,2BAA2B;EAC7B;;EAEA;IACE,oBAAoB;IACpB,WAAW;EACb;;EAEA;IACE,qBAAqB;IACrB,YAAY;EACd;;EAEA;IACE,qBAAqB;EACvB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;;;IAGE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,wBAAwB;EACxB,gCAAgC;EAChC,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,iCAAiC;EACjC,kBAAkB;EAClB,kBAAkB;AACpB","sourcesContent":["/* ========== Base Styles ========== */\n.clinic-chat-wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  background-color: var(--clr-grey-10);\n  margin: 1rem;\n  padding: 10px;\n  box-sizing: border-box;\n  position: relative;\n  overflow: auto;\n  border: 3px solid var(--clr-primary-3);\n}\n\n.clinic-chat-page {\n  display: flex;\n  flex-direction: row;\n  background-color: var(--clr-white);\n  width: 90%;\n  max-width: 1200px;\n  min-width: 700px;\n  min-height: 500px;\n  height: 80vh;\n  border-radius: 10px;\n  overflow: auto;\n  box-shadow: var(--shadow-3);\n  resize: both;\n  position: relative;\n}\n\n.clinic-chat-page::after {\n  content: '';\n  position: absolute;\n  width: 16px;\n  height: 16px;\n  right: 0;\n  bottom: 0;\n  background: transparent;\n  cursor: se-resize;\n}\n\n.chat-sidebar {\n  width: 250px;\n  min-width: 180px;\n  max-width: 400px;\n  flex-shrink: 0;\n  background-color: var(--grey-100);\n  padding: 1rem;\n  overflow-y: auto;\n  border-right: 1px solid var(--grey-300);\n  transition: all 0.3s ease;\n  z-index: 99;\n}\n\n.sidebar-header {\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n.sidebar-header-top {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-right: 8px;\n}\n\n.collapse-btn {\n  background: none;\n  border: none;\n  font-size: 1.2rem;\n  cursor: pointer;\n  color: var(--grey-500);\n  transition: color 0.2s;\n}\n\n.collapse-btn:hover {\n  color: var(--clr-primary-5);\n}\n\n.patient-search {\n  width: 100%;\n  padding: 0.5rem 0.75rem;\n  margin-bottom: 1rem;\n  border: 1px solid var(--grey-300);\n  border-radius: 6px;\n  font-size: 0.95rem;\n}\n\n.chat-sidebar h2 {\n  margin: 0;\n  font-size: 1.1rem;\n  color: var(--clr-grey-2);\n}\n\n.chat-participant {\n  padding: 0.75rem;\n  border-radius: 6px;\n  margin-bottom: 0.5rem;\n  cursor: pointer;\n  transition: background 0.2s ease;\n  background-color: var(--clr-white);\n}\n\n.chat-participant:hover {\n  background-color: var(--grey-200);\n}\n\n.chat-participant.active {\n  background-color: var(--clr-primary-9);\n  font-weight: bold;\n}\n\n.chat-main {\n  flex-grow: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  background-color: var(--clr-white);\n  overflow: hidden;\n  height: 100%;\n  max-height: 100%;\n}\n\n.chat-header {\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  padding: 1rem 1.5rem;\n  background-color: var(--clr-primary-5);\n  color: var(--clr-white);\n  font-size: 1.1rem;\n  font-weight: bold;\n  box-shadow: var(--shadow-1);\n}\n\n.chat-header button {\n  background: none;\n  border: none;\n  font-size: 1.2rem;\n  color: var(--clr-white);\n  cursor: pointer;\n  margin-right: 0.75rem;\n}\n\n.channel-tabs {\n  display: flex;\n  gap: 1rem;\n  padding: 0.75rem 1.5rem;\n  border-bottom: 1px solid var(--grey-300);\n  background-color: var(--grey-100);\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.channel-tabs button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 6px 12px;\n  border-radius: 4px;\n  transition: background 0.2s;\n  color: var(--clr-primary-5);\n}\n\n.channel-tabs button:hover {\n  background-color: var(--clr-primary-10);\n}\n\n.channel-tabs button.active {\n  background-color: var(--clr-primary-5);\n  color: var(--clr-white);\n}\n\n.chat-body {\n  flex: 1;\n  padding: 1rem 1.5rem;\n  overflow-y: auto;\n  background-color: var(--grey-100);\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.chat-msg {\n  max-width: 60%;\n}\n\n.chat-msg.patient {\n  align-self: flex-start;\n}\n\n.chat-msg.clinic {\n  align-self: flex-end;\n}\n\n.chat-bubble {\n  padding: 0.75rem 1rem;\n  border-radius: 18px;\n  background-color: var(--grey-200);\n  font-size: 0.95rem;\n  position: relative;\n  color: var(--grey-900);\n  box-shadow: var(--shadow-1);\n}\n\n.chat-msg.clinic .chat-bubble {\n  background-color: var(--clr-primary-9);\n  color: var(--clr-primary-1);\n}\n\n.chat-bubble.email-channel {\n  border-left: 4px solid #ff9800;\n  background-color: #fff8e1;\n  color: #5d4037;\n}\n\n.chat-channel-label {\n  display: inline-block;\n  font-size: 0.65rem;\n  background-color: #ff9800;\n  color: white;\n  padding: 2px 6px;\n  border-radius: 10px;\n  margin-top: 6px;\n  margin-left: 4px;\n  font-weight: bold;\n}\n\n.chat-time {\n  font-size: 0.75rem;\n  margin-top: 0.25rem;\n  text-align: right;\n  color: var(--grey-600);\n}\n\n.chat-input-bar {\n  position: sticky;\n  bottom: 0;\n  padding: 1rem 1.5rem;\n  display: flex;\n  gap: 1rem;\n  border-top: 1px solid var(--grey-300);\n  background-color: var(--grey-50);\n  z-index: 10;\n}\n\n.chat-input-bar input {\n  flex: 1;\n  padding: 0.7rem 1rem;\n  border: 1px solid var(--grey-300);\n  border-radius: 20px;\n  font-size: 1rem;\n}\n\n.chat-input-bar button {\n  padding: 0.7rem 1.5rem;\n  border: none;\n  border-radius: 20px;\n  background-color: var(--clr-primary-5);\n  color: var(--clr-white);\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.chat-input-bar button:hover {\n  background-color: var(--clr-primary-4);\n}\n\n.sidebar-resizer {\n  width: 6px;\n  min-width: 6px;\n  cursor: col-resize;\n  background-color: var(--grey-300);\n  transition: background-color 0.2s ease;\n}\n\n.sidebar-resizer:hover {\n  background-color: var(--grey-400);\n}\n\n.sidebar-resizer::after {\n  content: '';\n  display: block;\n  width: 2px;\n  height: 40%;\n  margin: auto;\n  background-color: var(--grey-500);\n}\n\n.collapsed-toggle {\n  width: 24px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: var(--grey-100);\n  border-right: 1px solid var(--grey-300);\n}\n\n.collapsed-toggle button {\n  background: none;\n  border: none;\n  font-size: 1.2rem;\n  cursor: pointer;\n  color: var(--grey-500);\n  transition: color 0.2s;\n}\n\n.collapsed-toggle button:hover {\n  color: var(--clr-primary-5);\n}\n\n.clinic-chat-wrapper.fullscreen {\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  background-color: var(--grey-100);\n  padding: 0;\n}\n\n.clinic-chat-wrapper.fullscreen .clinic-chat-page {\n  width: 100vw;\n  height: 100vh;\n  max-width: none;\n  max-height: none;\n  border-radius: 0;\n  resize: none;\n}\n\n.fullscreen-toggle {\n  position: absolute;\n  top: 10px;\n  right: 20px;\n  z-index: 99;\n}\n\n.fullscreen-toggle button {\n  background-color: var(--clr-primary-5);\n  color: var(--clr-white);\n  border: none;\n  padding: 6px 12px;\n  font-size: 0.85rem;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.fullscreen-toggle button:hover {\n  background-color: var(--clr-primary-4);\n}\n\n@media (max-width: 768px) {\n  .chat-sidebar {\n    width: 100% !important;\n  }\n\n  .chat-main {\n    display: none;\n  }\n\n  .chat-main.active {\n    display: block;\n    width: 100%;\n  }\n\n  .clinic-chat-page {\n    flex-direction: column;\n    width: 100%;\n    height: 100vh;\n    min-width: auto;\n    min-height: auto;\n    border-radius: 0;\n    box-shadow: none;\n    resize: none;\n  }\n\n  .chat-sidebar {\n    height: 100%;\n    border-right: none;\n    border-bottom: 1px solid var(--grey-300);\n    position: relative;\n    z-index: 2;\n    overflow-y: auto;\n  }\n\n  .chat-main {\n    position: absolute;\n    top: 0;\n    left: 0;\n    background: var(--clr-white);\n    z-index: 3;\n    display: none;\n    flex-direction: column;\n  }\n\n  .chat-main.active {\n    display: flex;\n  }\n\n  .chat-header {\n    padding: 1rem;\n    font-size: 1rem;\n    justify-content: flex-start;\n  }\n\n  .channel-tabs {\n    padding: 0.5rem 1rem;\n    gap: 0.5rem;\n  }\n\n  .chat-body {\n    padding: 0.75rem 1rem;\n    gap: 0.75rem;\n  }\n\n  .chat-input-bar {\n    padding: 0.75rem 1rem;\n  }\n\n  .chat-input-bar input,\n  .chat-input-bar button {\n    font-size: 0.9rem;\n  }\n\n  .fullscreen-toggle,\n  .sidebar-resizer,\n  .collapsed-toggle {\n    display: none;\n  }\n}\n\n.welcome-message {\n  padding: 30px;\n  text-align: center;\n  color: var(--clr-grey-3);\n  background-color: var(--grey-50);\n  border-radius: 12px;\n  margin: 40px auto;\n  max-width: 675px;\n  box-shadow: var(--shadow-1);\n  font-family: var(--ff-secondary);\n}\n\n.welcome-message h3 {\n  font-size: 24px;\n  margin-bottom: 16px;\n  color: var(--clr-grey-1);\n}\n\n.welcome-message p {\n  font-size: 16px;\n  line-height: 1.6;\n  color: var(--grey-700);\n}\n\n.sidebar-subtitle {\n  font-size: 0.9rem;\n  color: var(--grey-600);\n  margin-top: 4px;\n  margin-bottom: 12px;\n}\n\n.sidebar-search-container {\n  padding: 0 12px 12px;\n}\n\n.patient-search {\n  width: 100%;\n  padding: 8px 10px;\n  border: 1px solid var(--grey-300);\n  border-radius: 6px;\n  font-size: 0.95rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
